import { getNativeInfo } from "../jsbridge"
import qs from "qs"

function getCookie(name: string) {
    if (typeof window !== 'undefined') {
      const value = `; ${document.cookie}`
      const parts = value.split(`; ${name}=`)
      if (parts.length === 2) return parts?.pop()?.split(';').shift()
    }
    return ''
  }
  
export const _getToken = async () => {
    let token = getCookie('token') || ''
    const { _TOKEN } = qs.parse(window.location.search, { ignoreQueryPrefix: true })
    if (_TOKEN && token !== _TOKEN) {
      token = _TOKEN as string
    }
    if (!token) {
      const nativeInfo = await getNativeInfo().catch(e => {
        return Promise.resolve({ token: '' })
      })
      token = nativeInfo?.token
    }
    return token
  }

  export const _getGToken = async () => {
    let gtoken = getCookie('gtoken') || ''
    if (!gtoken) {
      const nativeInfo = await getNativeInfo().catch(e => {
        return Promise.resolve({ gtoken: '' })
      })
      gtoken = nativeInfo?.gtoken
    }
    return gtoken
  }